import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedInOutlined';

export const AuditIcon = AssignmentTurnedInIcon;
